var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"height":"100%"}},[_c('div',{ref:"gmap",staticStyle:{"height":"100%"}}),_c('gmap-cluster',_vm._l((_vm.markers),function(m){return _c('gmap-marker',{key:m.key,attrs:{"geoCoord":m.geoCoord,"title":m.title,"subtitle":m.subtitle,"mdi":m.mdi,"icon":m.icon,"id":m.id,"geoCoordId":m.geoCoordId,"coordinates":m.coordinates}})}),1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }